import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueObserveVisibility from "vue-observe-visibility";
import VTooltip from "vue-directive-tooltip";
import "vue-directive-tooltip/dist/vueDirectiveTooltip.css";
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(VTooltip);
Vue.use(VueObserveVisibility);
Vue.use(Vue2TouchEvents)

new Vue({
  el: "#attendee-module",
  router,
  store,
  render: (h) => h(App),
});
